import { TemplateConfig } from '../../template-config.interface';

export const disneyBinge: TemplateConfig = {
  id: 'binge',
  clientId: 'DISNEY',
  title: 'Maratonear',
  description: 'Template para maratones',
  aspectRatio: 'vertical',
  disabled: true,
  image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/maratonear.png',
  optimized_image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/optimized/maratonear.png',
  video: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/previews/para_maratonear.mp4',
  formFields: [],
  promptTemplate: ''
};
